import { Link } from "react-router-dom";
import { ArrowRight, Check, Hammer } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";
import SEOHead from "@/components/SEOHead";
import HeroPremium from "@/components/HeroPremium";
import { CTA_DEVIS } from "@/data/forms";

const services = [
  {
    num: "01", title: "Construction",
    desc: "Nous proposons des services de construction pour tous types de projets, des maisons individuelles aux bâtiments commerciaux. Notre équipe gère chaque étape, du terrassement à la finition.",
    points: ["Gros oeuvres et fondations", "Construction clés en main", "Conformité aux normes belges", "Suivi de chantier rigoureux"],
    img: "https://images.unsplash.com/photo-1710585761854-57ff6839395c?w=800&q=80"
  },
  {
    num: "02", title: "Rénovation intérieur & extérieur",
    desc: "Nous sommes spécialisés dans la rénovation complète de maisons et appartements. Cuisine, salle de bain, façade — nous transformons votre espace avec soin et précision.",
    points: ["Rénovation cuisine et salle de bain", "Façades et isolation thermique", "Aménagement d'intérieur", "Rénovation de bâtiments anciens"],
    img: "https://images.unsplash.com/photo-1764697757348-e3c87b076310?w=800&q=80"
  },
  {
    num: "03", title: "Travaux de toiture",
    desc: "Notre équipe d'experts en toiture possède une vaste expérience dans la pose, la réparation et l'isolation de tous types de toitures. Tuiles, ardoises, toiture plate — nous maîtrisons toutes les techniques.",
    points: ["Pose et remplacement complet", "Réparation de fuites urgentes", "Isolation thermique performante", "Toitures plates et en pente"],
    img: "https://images.pexels.com/photos/31771166/pexels-photo-31771166.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    num: "04", title: "Plomberie & Chauffage",
    desc: "Installation, remplacement et dépannage de tous systèmes de plomberie et chauffage. Chaudières, radiateurs, sanitaires — nous intervenons rapidement et efficacement.",
    points: ["Installation de chaudières", "Remplacement de sanitaires", "Débouchage de canalisations", "Plancher chauffant et radiateurs"],
    img: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    num: "05", title: "Électricité",
    desc: "Mise aux normes, nouvelles installations et dépannage électrique. Nous garantissons des installations conformes et sécurisées pour votre habitation ou entreprise.",
    points: ["Mise aux normes RGIE", "Tableaux électriques et câblage", "Éclairage intérieur et extérieur", "Domotique et automatisation"],
    img: "https://images.unsplash.com/photo-1660330590022-9f4ff56b63f6?w=800&q=80"
  },
  {
    num: "06", title: "Terrassement",
    desc: "Travaux de terrassement, nivellement, évacuation des terres et aménagement extérieur. Nous disposons du matériel nécessaire pour tous types de chantiers.",
    points: ["Excavation et nivellement", "Fondations et drainage", "Évacuation des terres", "Aménagement extérieur"],
    img: "https://images.unsplash.com/photo-1580901368813-93220b510345?w=800&q=80"
  },
];

export default function Services() {
  return (
    <div data-testid="services-page" style={{ backgroundColor: '#ffffff', color: '#1a1a1a' }}>
      <SEOHead title="Nos services | VGI Construct – Rénovation, extension, toiture, électricité – Bruxelles & Brabant" description="Rénovation complète, extension, gros-œuvre, toiture, châssis, isolation, plafonnage, chapes, électricité, plomberie, chauffage. VGI Construct intervient à Bruxelles et dans tout le Brabant. Devis gratuit – réponse sous 48 h." path="/services" />
      {/* HERO PREMIUM */}
      <HeroPremium
        badge="Nos expertises"
        titleWhite="Tout ce que nous"
        titleRed="savons faire"
        photo="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=700&q=85&fm=webp"
        photoAlt="Chantier de ferraillage VGI Construct"
        photoBadgeIcon={Hammer}
        photoBadgeTitle="6 Métiers"
        photoBadgeSub="maîtrisés"
        decoNumber="03"
      />

      {/* SERVICES LIST */}
      <section style={{ backgroundColor: '#ffffff', paddingBottom: '80px' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          {services.map((svc, i) => {
            const imgLeft = i % 2 === 0;
            return (
              <ScrollReveal key={svc.num}>
                <div data-testid={`service-${svc.num}`} style={{ borderBottom: i < services.length - 1 ? '1px solid #e8e8e8' : 'none' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '48px', padding: '64px 0', alignItems: 'center' }} className="lg:!grid-cols-2">
                    {/* IMAGE */}
                    <div style={{ order: imgLeft ? 0 : 1 }} className={imgLeft ? "" : "lg:!order-2"}>
                      <div style={{ overflow: 'hidden', borderRadius: '6px' }}>
                        <img src={svc.img} alt={svc.title} loading="lazy" width="800" height="600" style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', display: 'block' }} />
                      </div>
                    </div>
                    {/* TEXT */}
                    <div style={{ order: imgLeft ? 1 : 0 }} className={imgLeft ? "" : "lg:!order-1"}>
                      <span style={{ color: '#8B0000', fontSize: '14px', fontWeight: 800, letterSpacing: '0.15em', textTransform: 'uppercase' }}>{svc.num}</span>
                      <h2 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: 900, color: '#1a1a1a', marginTop: '8px', marginBottom: '16px', lineHeight: 1.2 }}>
                        {svc.title}
                      </h2>
                      <p style={{ color: '#444444', fontSize: '16px', lineHeight: 1.8, marginBottom: '24px' }}>{svc.desc}</p>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '28px' }}>
                        {svc.points.map(pt => (
                          <div key={pt} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Check size={16} color="#8B0000" strokeWidth={3} />
                            <span style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: 600 }}>{pt}</span>
                          </div>
                        ))}
                      </div>
                      <Link to="/demande-devis" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#8B0000', fontWeight: 700, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.05em', textDecoration: 'none' }}>
                        {CTA_DEVIS} <ArrowRight size={16} />
                      </Link>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ backgroundColor: '#f8f8f8', padding: '80px 0', textAlign: 'center' }}>
        <ScrollReveal>
          <h2 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: 900, color: '#1a1a1a', marginBottom: '24px' }}>Un projet en tête ?</h2>
          <p style={{ color: '#444444', fontSize: '18px', marginBottom: '32px', maxWidth: '500px', marginLeft: 'auto', marginRight: 'auto' }}>Contactez-nous pour un devis gratuit et sans engagement.</p>
          <Link to="/demande-devis" data-testid="services-cta" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', backgroundColor: '#8B0000', color: '#ffffff', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '14px 36px', textDecoration: 'none', fontSize: '14px', borderRadius: '100px' }}>
            {CTA_DEVIS} <ArrowRight size={16} />
          </Link>
        </ScrollReveal>
      </section>
    </div>
  );
}
